import React, { useState } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import Fade from '@mui/material/Fade';
import { Button } from '@mui/material';
import AppIcons from '../../../assets/images/icons';
import SVGIcons from '../../../assets/images/icons/svgIcons';

import './burgerMenu.scss';




export default function BurgerMenu() {

  const wdpNavItems = [
    {
      link: '#home',
      title: 'Home',
    },
    
  ];
  const wdpNavItems2 = [
    {
      link: 'contact-us',
      title: 'Contact us',
    }
  ];
  const wdpNavItems3 = [
    {
      link: '#about',
      title: 'About',
    },
    {
      link: '#projects',
      title: 'Projects',
    },
    {
      link: '#investments',
      title: 'Investments',
    },
    {
      link: '#news',
      title: 'News',
    },
  ];

  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);

  /**
   * Handles the submenu click
   * @param {Event} event 
   */
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  /**
   * Handles the submenu close
   */
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  const [show, setShow] = useState(false);
  const showDropdown = () => {
    setShow(!show);
  }
  const hideDropdown = () => {
    setShow(false);
  }

  if(show){
    document.body.style.paddingRight = "18px";
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.paddingRight = null;
    document.body.style.overflow = null;
  }
  
  return (
    <>
      <div className='burger-menu-sec'>
        <div className='logo-wrap'>
          <div className={`mainMenuBox f-wrp ${show === true ? 'mobNav-open' : 'mobNav-hide'}`}>
            <Link className='main-logo' to={'/'}><img src={AppIcons.logo} alt='burger menu' /></Link>
            <ul className={`main-Menu-list ${show === true ? "open" : "close"}`}>
              {wdpNavItems.filter((item) => !item.isHidden).map((element) => (
                <li key={element.title} className='each-menuItem'>
                  <NavHashLink onClick={hideDropdown} smooth to={`/${element.link}`} style={{ width: '100%' }} >
                    <Button sx={{ textAlign: 'center' }} onClick={hideDropdown}>
                      {element.icon ? <span className='menu-icon'><img src={element.icon} alt={element.title} /></span> : null}
                      <span>{element.title}</span>
                    </Button>
                  </NavHashLink>
                </li>
              ))}
              {wdpNavItems2.filter((item) => !item.isHidden).map((element) => (
                <li key={element.title} className='each-menuItem'>
                  <Link onClick={hideDropdown} to={`/${element.link}`} style={{ width: '100%' }} >
                    <Button sx={{ textAlign: 'center' }} onClick={hideDropdown}>
                      {element.icon ? <span className='menu-icon'><img src={element.icon} alt={element.title} /></span> : null}
                      <span>{element.title}</span>
                    </Button>
                  </Link>
                </li>
              ))}
              {wdpNavItems3.filter((item) => !item.isHidden).map((element) => (
                <li key={element.title} className='each-menuItem'>
                  <NavHashLink onClick={hideDropdown} smooth to={`/${element.link}`} style={{ width: '100%' }} >
                    <Button sx={{ textAlign: 'center' }} onClick={hideDropdown}>
                      {element.icon ? <span className='menu-icon'><img src={element.icon} alt={element.title} /></span> : null}
                      <span>{element.title}</span>
                    </Button>
                  </NavHashLink>
                </li>
              ))}
            </ul>
          </div>

          <Button
            id="fade-button"
            // aria-controls={open ? 'fade-menu' : undefined}
            // aria-haspopup="true"
            // aria-expanded={open ? 'true' : undefined}
            onClick={showDropdown}
            className={`burgerButton ${show === true ? 'show' : 'hide'}`}
          >
            <SVGIcons.UpArrowIcon />
          </Button>
        </div>

        {/* <Menu
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          PaperProps={{
            style: {
              maxWidth: '250px',
            }
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          className='menu-main-wrp wdpNavItems'
        >
          {wdpNavItems.filter((item) => !item.isHidden).map((element) => (
            <MenuItem key={element.title} onClick={handleClose} className='each-menuItem'>
              <Link onClick={handleClose} smooth to={`${element.link}`} style={{ width: '100%' }} >
                <Button sx={{ textAlign: 'center' }} onClick={handleClose}>
                  {element.icon ? <span className='menu-icon'><img src={element.icon} alt={element.title} /></span> : null}
                  <span>{element.title}</span>
                </Button>
              </Link>
            </MenuItem>
          ))}
        </Menu> */}
      </div>
    </>

  )

}